export enum EnumContextEvent {
  SIGNUP = 'signup',
  LOGIN = 'login',
  FORGOT = 'forgot',
}
